import { ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

type TAccessMethod = () => Promise<string>;

export default function setAuthorizationHeader(getAccessTokenSilently: TAccessMethod): ApolloLink {
  return setContext(async (request, previousContext) => {
    try {
      const token = await getAccessTokenSilently();
      return {
        ...previousContext,
        headers: {
          ...previousContext.headers,
          Authorization: `Bearer ${token}`,
        },
      };
    } catch (e) {
      return previousContext;
    }
  });
}
